import GlobalAttachmentPreview from "./src/main.vue";

GlobalAttachmentPreview.install = (Vue) => {
    Vue.component(GlobalAttachmentPreview.name, GlobalAttachmentPreview);
}

export default GlobalAttachmentPreview;